<template>
  <div id="user">
    <v-container>
      <v-row>
        <v-col>
          <v-card v-if="!loading" class="rounded-xl ma-2" elevation="7">
            <v-container class="text-center">
              <v-avatar
                v-if="user.user.avatar"
                :src="'/i/' + user.user.avatar"
                align="center"
                class="text-center"
                height="90"
                width="90"
              >
                <img v-if="user.user.avatar" :src="'/i/' + user.user.avatar" />
              </v-avatar>
              <v-avatar
                v-if="!user.user.avatar"
                :src="'/api/v1/userutils/identicon/' + user.user.username"
                align="center"
                class="text-center justify-center"
                justify="center"
                size="90"
              >
                <img
                  v-if="!user.user.avatar"
                  :src="'/api/v1/userutils/identicon/' + user.user.username"
                />
              </v-avatar>
              <br />
              <span class="text-h4"> {{ user.user.username }} </span><br />
              <v-chip
                v-if="
                  user.user.plan.internalName !== 'FREE' &&
                  user.user.plan.internalName.indexOf('CSTM_TIER_') >= 0
                "
                :color="user.user.plan.color"
                class="ma-2"
                text-color="white"
              >
                <v-icon> {{ user.user.plan.icon }}</v-icon
                >&nbsp;
                {{ user.user.plan.name }}
              </v-chip>
              <v-chip
                v-if="user.user.administrator"
                class="ma-2"
                color="red"
                text-color="white"
              >
                <v-icon> mdi-gavel</v-icon>&nbsp;Administrator
              </v-chip>
              <v-chip
                v-if="user.user.moderator"
                class="ma-2"
                color="green"
                text-color="white"
              >
                <v-icon> mdi-shield</v-icon>&nbsp;Moderator
              </v-chip>
              <v-chip
                v-if="
                  user.user.plan.internalName !== 'FREE' &&
                  user.user.plan.internalName.indexOf('CSTM_TIER_')
                "
                :color="user.user.plan.color"
                class="ma-2"
                text-color="white"
              >
                <v-icon> {{ user.user.plan.icon }}</v-icon
                >&nbsp;
                {{ user.user.plan.name }}
              </v-chip>
              <v-chip
                v-if="user.user.beta"
                class="ma-2"
                color="deep-purple"
                text-color="white"
              >
                β Beta
              </v-chip>
            </v-container>
          </v-card>
          <v-card v-if="loading" class="rounded-xl ma-2" elevation="7">
            <v-container class="text-center">
              <p class="text-lg-h4">Loading...</p>
            </v-container>
          </v-card>
          <br />
          <v-card v-if="!loading" class="rounded-xl ma-2" elevation="7">
            <v-container class="text-center">
              <p
                class="text-h4"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                About {{ user.user.username }}
              </p>
              <p>
                Description:
                {{ user.user.description }}
              </p>
              <p>
                Registration Date:
                {{
                  dayjs(user.user.createdAt).format("Do of MMMM YYYY, h:mm A")
                }}
              </p>
            </v-container>
          </v-card>
          <br />
          <v-card
            class="rounded-xl text-center ma-2"
            elevation="7"
            v-if="hoursMost"
          >
            <v-container>
              <p
                class="text-h4"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Upload Distribution
              </p>
              <h3 class="mt-n3">
                {{ user.user.username }} uploads the most at
                {{ hoursMost.hour }} with {{ hoursMost.count }} uploads!
              </h3>
              <ChartBar
                :chart-data="hoursGraph"
                v-if="hoursGraph"
                :chart-options="options"
              ></ChartBar>
            </v-container>
            <small class="grey--text">Higher is better?</small><br />
            <small class="grey--text">Australia/Melbourne timezone.</small>
          </v-card>
          <br />
          <v-card v-if="false" class="rounded-xl ma-2" elevation="7">
            <v-container class="text-center">
              <p
                class="text-h4"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Total Upload Stats
              </p>
              <ChartUser
                :chart-data="chartDataTotal"
                :chart-options="chartOptions"
              ></ChartUser>
            </v-container>
          </v-card>
        </v-col>
        <v-col v-if="!loading">
          <v-row no-gutters>
            <v-col md="4" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    TPU Hours
                  </p>
                  <b class="text-h4">{{ user.stats.pulse }}h</b>
                </v-container>
              </v-card>
            </v-col>
            <v-col md="4" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    User ID
                  </p>
                  <b class="text-h4">{{ user.user.id }}</b>
                </v-container>
              </v-card>
            </v-col>
            <v-col md="4" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    Uploads
                  </p>
                  <b class="text-h4">{{ user.stats.uploads }}</b>
                </v-container>
              </v-card>
            </v-col>
            <v-col md="4" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    Used
                  </p>
                  <b class="text-h4">{{ fileSize(user.user.quota) }}</b>
                </v-container>
              </v-card>
            </v-col>
            <v-col md="4" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    Collections
                  </p>
                  <b class="text-h4">{{ user.stats.collections }}</b>
                </v-container>
              </v-card>
            </v-col>
            <v-col md="4" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    Collectivized Items
                  </p>
                  <b class="text-h4">{{ user.stats.collectionItems }}</b>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
          <br />
          <v-col>
            <v-card
              v-if="user.stats.uploadGraph"
              class="rounded-xl"
              elevation="7"
            >
              <v-container class="text-center">
                <p
                  class="text-h4"
                  v-bind:class="{
                    gradient: !$store.state.site.whitelabel,
                    troploGradient: $store.state.site.whitelabel
                  }"
                >
                  Upload Stats
                </p>
                <ChartUser
                  :chart-data="chartData"
                  :chart-options="chartOptions"
                ></ChartUser>
              </v-container>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              v-if="user.user.discordUserCache"
              class="rounded-xl"
              elevation="7"
            >
              <v-container class="text-center">
                <p
                  class="text-h4"
                  v-bind:class="{
                    gradient: !$store.state.site.whitelabel,
                    troploGradient: $store.state.site.whitelabel
                  }"
                >
                  Discord
                </p>
                <!-- <v-avatar class="text-center" align="center" height="90" width="90" v-if="user.user.discordUserCache.avatar">
                 <v-img :src="'https://cdn.discordapp.com/avatars/' + user.user.discordUserCache.id + '/' + user.user.discordUserCache.avatar + '.png'"></v-img>
               </v-avatar>-->
                <p class="text-h6">
                  {{ user.user.discordUserCache.username }}#{{
                    user.user.discordUserCache.discriminator
                  }}
                </p>
              </v-container>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"
import ChartUser from "@/components/ChartUser"
import ChartBar from "@/components/ChartBar"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)

export default {
  name: "User",
  components: {
    ChartUser,
    ChartBar
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false
        }
      },
      loading: true,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false
        }
      },
      user: {
        user: {
          username: "Loading...",
          premium: false,
          administrator: false
        },
        stats: {
          uploads: 0
        }
      }
    }
  },
  methods: {
    fileSize(fileSize) {
      let i = -1
      let byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      do {
        fileSize = fileSize / 1024
        i++
      } while (fileSize > 1024)

      return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i]
    },
    dayjs(params) {
      return dayjs(params)
    },
    getUserData() {
      this.loading = true
      this.axios
        .get("/api/v1/user/" + this.$route.params.user)
        .then((res) => {
          this.loading = false
          this.user = res.data
          this.user.user.discordUserCache = JSON.parse(
            res.data.user.discordUserCache
          )
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  computed: {
    hoursMost() {
      if (this.user?.stats?.hours) {
        let hours = Object.entries(this.user.stats.hours)
        hours.sort((a, b) => b[1] - a[1])
        return {
          hour: hours[0][0],
          count: hours[0][1]
        }
      } else {
        return null
      }
    },
    hoursGraph() {
      if (this.user?.stats?.hours) {
        return {
          labels: Object.keys(this.user.stats.hours),
          datasets: [
            {
              label: "Uploads",
              data: Object.values(this.user.stats.hours),
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
              borderWidth: 1
            }
          ]
        }
      } else {
        return null
      }
    },
    chartData() {
      if (this.user?.stats?.uploadGraph) {
        return {
          labels: this.user.stats.uploadGraph.labels,
          datasets: [
            {
              label: "Uploads",
              data: this.user.stats.uploadGraph.data,
              backgroundColor: "transparent",
              borderColor: "#0179F3",
              pointBackgroundColor: "#181818"
            }
          ]
        }
      } else {
        return []
      }
    },
    chartDataTotal() {
      if (this.user?.stats?.uploadGraphAllTime) {
        return {
          labels: this.user.stats.uploadGraphAllTime.labels,
          datasets: [
            {
              label: "Uploads",
              data: this.user.stats.uploadGraphAllTime.data,
              backgroundColor: "transparent",
              borderColor: "#0179F3",
              pointBackgroundColor: "#181818"
            }
          ]
        }
      } else {
        return []
      }
    }
  },
  mounted() {
    this.getUserData()
  },
  watch: {
    $route() {
      this.user = {}
      this.getUserData()
    }
  }
}
</script>

<style scoped></style>
